import * as actionTypes from "./actionTypes";

const initialState = {
    breadcrumbs: [],
    topHeaderTitle: undefined
};

const sharedReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.UPDATE_CUSTOM_BREADCRUMBS:
            const { concatenate, newBreadcrumbs = [] } = payload;
            const breadcrumbs = concatenate ?
                [...state.breadcrumbs, ...newBreadcrumbs] :
                [...newBreadcrumbs];

            return {
                ...state,
                breadcrumbs
            };
        case actionTypes.UPDATE_TOP_HEADER_TITLE:
            return {
                ...state,
                topHeaderTitle: payload
            };
        default:
            return state;
    }
};

export default sharedReducer;